import { render } from "./ButtonStyle.vue?vue&type=template&id=4c536a50"
import script from "./ButtonStyle.vue?vue&type=script&lang=js"
export * from "./ButtonStyle.vue?vue&type=script&lang=js"
script.render = render

export default script